import { _js } from '@ifixit/localize';
import { SimpleGrid } from '@chakra-ui/react';
import {
   faCalendarDays,
   faLanguage,
   faPencil,
   faCommentsQuestionCheck,
   faBook,
   IconDefinition,
} from '@fortawesome/pro-duotone-svg-icons';
import OptionCard from './option';

export const enum CommunityPageType {
   LANDING_PAGE,
   PARTICIPATION,
}

interface Option {
   linkKey: string;
   imageIndex: number;
   altText: string;
   icon: IconDefinition;
   title: string;
   description: string;
   buttonText: string;
}

const AnswersOption: Option = {
   linkKey: 'answers',
   imageIndex: 0,
   altText: 'Solve Problems',
   icon: faCommentsQuestionCheck,
   title: _js('Solve Problems'),
   description: _js(
      'Get help from friendly fixers and share a helping \
      hand with others around the world.'
   ),
   buttonText: _js('Answers Forum'),
};

const StoriesOption: Option = {
   linkKey: 'stories',
   imageIndex: 1,
   altText: 'Write a Story',
   icon: faPencil,
   title: _js('Write a Story'),
   description: _js(
      'Share your repair experience to help others learn \
      what to do (and what not to do).'
   ),
   buttonText: _js('Write a Story'),
};

const TranslateOption: Option = {
   linkKey: 'translate',
   imageIndex: 2,
   altText: 'Help Translate',
   icon: faLanguage,
   title: _js('Help Translate'),
   description: _js(
      'Translate iFixit into your mother tongue and \
      make repair information available to everyone!'
   ),
   buttonText: _js('Start Translating'),
};

const NewGuideOption: Option = {
   linkKey: 'guideNew',
   imageIndex: 3,
   altText: 'Teach a Repair',
   icon: faBook,
   title: _js('Teach a Repair'),
   description: _js(
      'No one knows how to fix everything, but\
      everyone knows how to fix something.'
   ),
   buttonText: _js('Create a Guide'),
};

const EventsOption: Option = {
   linkKey: 'events',
   imageIndex: 4,
   altText: 'Events',
   icon: faCalendarDays,
   title: _js('Events'),
   description: _js(
      'Find a repair event near you and fix \
      things together.'
   ),
   buttonText: _js('Find Events'),
};

export const OptionsDisplay = ({ images, lang, links, page }: any) =>
   page == CommunityPageType.LANDING_PAGE ? (
      <SimpleGrid columns={{ base: 1, sm: 2, lg: 4 }} spacing={5} marginTop={5}>
         <OptionCard images={images} links={links} option={AnswersOption} />
         <OptionCard images={images} links={links} option={StoriesOption} />
         {lang == 'en' ? (
            <OptionCard images={images} links={links} option={NewGuideOption} />
         ) : (
            <OptionCard images={images} links={links} option={TranslateOption} />
         )}
         <OptionCard images={images} links={links} option={EventsOption} />
      </SimpleGrid>
   ) : (
      <SimpleGrid columns={{ base: 1, sm: 2, lg: 4 }} spacing={5} marginTop={5}>
         <OptionCard images={images} links={links} option={NewGuideOption} />
         <OptionCard images={images} links={links} option={AnswersOption} />
         <OptionCard images={images} links={links} option={TranslateOption} />
         <OptionCard images={images} links={links} option={EventsOption} />
      </SimpleGrid>
   );
